'use client';

import Link from 'next/link';
import { useDispatch, useSelector } from 'react-redux';

import type { AppHref } from '@/shared/lib/route';
import { Dialog } from '@/shared/ui/dialog';
import { Icon } from '@/shared/ui/icon';
import { IconButton } from '@/shared/ui/icon-button';

import { siteMenuActions, type SiteMenuRootState } from '../model/site-menu-slice';
import styles from './site-menu.module.scss';

const PRIMARY: ReadonlyArray<{ label: string; href: AppHref; note?: string }> = [
  { label: 'Каталог', href: '/catalog' },
  {
    label: 'Для тела',
    href: '/catalog?direction=body',
    note: 'Одежда для практик и каждого дня',
  },
  {
    label: 'Для мыслей',
    href: '/catalog?direction=mind',
    note: 'Дневники и инструменты для планов',
  },
  {
    label: 'Для атмосферы',
    href: '/catalog?direction=care',
    note: 'Свечи, уход и подарки',
  },
  { label: 'Подарочный набор', href: '/gift-set' },
  { label: 'Уход за тканями', href: '/care' },
];

const SECONDARY: ReadonlyArray<{ label: string; href: AppHref }> = [
  { label: 'Личный кабинет', href: '/account' },
  { label: 'Корзина', href: '/cart' },
  { label: 'Доставка и оплата', href: '/info/delivery' },
  { label: 'Служба заботы', href: '/info/support' },
];

/** Burger navigation (the design has only the button; the panel follows 01B styling). */
export function SiteMenu() {
  const open = useSelector((state: SiteMenuRootState) => state.siteMenu.open);
  const dispatch = useDispatch();
  const close = () => dispatch(siteMenuActions.closed());
  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!next) close();
      }}
      title="Меню"
      variant="left"
      width="26.25rem"
      className={styles.panel}
    >
      <div className={styles.top}>
        <Link href="/" className={styles.logo} onClick={close}>
          JVU
        </Link>
        <IconButton label="Закрыть меню" onClick={close}>
          <Icon name="close" size={20} strokeWidth={1.4} />
        </IconButton>
      </div>
      <nav aria-label="Основная навигация">
        <ul className={styles.primary}>
          {PRIMARY.map((item) => (
            <li key={item.label}>
              <Link href={item.href} className={styles.link} onClick={close}>
                <span className={styles.label}>{item.label}</span>
                {item.note && <span className={styles.note}>{item.note}</span>}
              </Link>
            </li>
          ))}
        </ul>
        <ul className={styles.secondary}>
          {SECONDARY.map((item) => (
            <li key={item.label}>
              <Link href={item.href} className={styles.small} onClick={close}>
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </Dialog>
  );
}
